import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsApgAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentCategory = control.get('documentCategory')!.value;
	const documentType = control.get('documentType')!.value;
	const contractNumber = control.get('contractNumber')!.value;
	const documentTypeArray = ['EGD017'];

	return !contractNumber && !!documentType && documentCategory ===  "EGD02"
	            && !documentTypeArray.includes(documentType)  ? { checkDocCategoryIsApgAndDocTypeAllowedFlag: true } : null;
};
